"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.useCalendar = void 0;
var tslib_1 = require("tslib");
var times_1 = (0, tslib_1.__importDefault)(require("lodash/times"));
var moment_timezone_1 = (0, tslib_1.__importDefault)(require("moment-timezone"));
var react_1 = require("react");
function useCalendar(options) {
    if (options === void 0) { options = {}; }
    var initialValue = options.initialValue, _a = options.timezone, timezone = _a === void 0 ? moment_timezone_1.default.tz.guess() : _a;
    var _b = (0, react_1.useState)(moment_timezone_1.default.tz(initialValue, timezone)), date = _b[0], setDate = _b[1];
    var days = generateDateRows(date);
    function increaseMonth() {
        setDate((0, moment_timezone_1.default)(date).add(1, 'month'));
    }
    function decreaseMonth() {
        setDate((0, moment_timezone_1.default)(date).subtract(1, 'month'));
    }
    function generateDateRows(initialDate) {
        var date = initialDate.isValid() ? initialDate : moment_timezone_1.default.tz({}, timezone);
        var year = date.year();
        var daysInMonth = date.daysInMonth();
        var rows = [[]];
        var rowIndex = 0;
        (0, times_1.default)(daysInMonth, function (num) {
            var temp = moment_timezone_1.default.tz({
                year: year,
                month: date.month(),
                day: num + 1,
            }, timezone);
            var dow = temp.day();
            rows[rowIndex].push(createDay(temp, date));
            if (dow === 6 && num !== daysInMonth - 1) {
                rowIndex += 1;
                rows.push([]);
            }
        });
        var rowLen = rows.length;
        var firstRow = rows[0];
        if (firstRow.length !== 7) {
            var backfillBy = 7 - firstRow.length;
            var first_1 = firstRow[0];
            (0, times_1.default)(backfillBy, function (num) {
                var d = moment_timezone_1.default.tz(first_1.value, timezone).startOf('week').add(num, 'day');
                firstRow.splice(num, 0, createDay(d, date));
            });
        }
        var lastRow = rows[rowLen - 1];
        if (lastRow.length !== 7) {
            var fillBy = 7 - lastRow.length;
            var lastLen = lastRow.length;
            var last_1 = lastRow[lastLen - 1];
            (0, times_1.default)(fillBy, function (num) {
                var d = moment_timezone_1.default.tz(last_1.value, timezone).add(num + 1, 'day');
                lastRow.push(createDay(d, date));
            });
        }
        return rows;
    }
    function createDay(day, currentDate) {
        var today = moment_timezone_1.default.tz({}, timezone);
        var isCurrentMonth = day.month() === currentDate.month();
        return {
            value: day.toISOString(),
            isToday: day.isSame(today, 'date'),
            isCurrentMonth: isCurrentMonth,
            dayOfWeek: day.toDate().getDay(),
        };
    }
    return {
        date: date.toISOString(),
        increaseMonth: increaseMonth,
        decreaseMonth: decreaseMonth,
        days: days,
        year: date.format('YYYY'),
        month: date.format('MMMM'),
        setYear: function (year) {
            setDate((0, moment_timezone_1.default)(date).year(year));
        },
        setMonth: function (month) {
            setDate((0, moment_timezone_1.default)(date).month(month));
        },
        timezone: timezone,
    };
}
exports.useCalendar = useCalendar;
//# sourceMappingURL=calendar.js.map